import React, {Dispatch, SetStateAction} from 'react';
import {IPresentation, IPresentationMeta} from '../../../../../incase-domain/presentation';
import CreateRoomModal from '../../../../pages/rooms/createRoom/CreateRoomModal';
import {WIZARD_CONFIG, WizardContext} from '../../steps';
import {ICreatedRoom} from '../../../../../incase-domain/rooms/room.editor';

interface IRoomCreationStepProps {
    wizardContext: WizardContext;
    setWizardContext: Dispatch<SetStateAction<WizardContext>>;
    presentation: IPresentationMeta;
    openRoomCreationModal: boolean;
    closeRoomCreationModal: () => void;
    setCreatedRoomId: (roomId: string) => void;
    setCreatedPresenterLinkCode: (code: string | undefined) => void;
}

function RoomCreationStep({
    presentation,
    openRoomCreationModal,
    closeRoomCreationModal,
    setWizardContext,
    wizardContext,
    setCreatedRoomId,
    setCreatedPresenterLinkCode,
}: IRoomCreationStepProps): JSX.Element | null {
    const handleClose = (): void => {
        setWizardContext({...wizardContext, currentStep: WIZARD_CONFIG.LIVE_EVENT});
        closeRoomCreationModal();
    };

    const handleRoomCreated = (createdRoom: ICreatedRoom): void => {
        setCreatedRoomId(createdRoom._id);
        setCreatedPresenterLinkCode(createdRoom.presenterLinkCode);
        setWizardContext({
            ...wizardContext,
            currentStep: WIZARD_CONFIG.ON_DEMAND.options.ACCESS_LINKS,
            previousStep: WIZARD_CONFIG.LIVE_EVENT,
        });
        closeRoomCreationModal();
    };

    if (!openRoomCreationModal) {
        return null;
    }

    return (
        <CreateRoomModal
            open={openRoomCreationModal}
            setOpen={handleClose}
            presentation={presentation as IPresentation}
            onRoomCreated={handleRoomCreated}
        />
    );
}

export default RoomCreationStep;
